import { KeyValue } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatSelectChange } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { BaseComponent } from "../base-component";
import { AFEmploymentDomain, KeyVal, AF_CONSTANTS } from "../model/af.model";
import { AuthService } from "../service/auth.service";
import { EmploymentService } from "../service/employment.service";
import { EventService } from "../service/event.service";
import {
  ChangeNavigationEvent,
  ProgressBarEvent,
  ValidateAndNavigateEvent,
  BeforeSubmitErrorEvent,
  SkipToMainContentEvent,
  CountryMistmatchEvent,
  EmploymentGapEvent,
  ShowErrorEvent,
} from "../service/events";
import { CustomValidatorsService } from "../service/custom-validators.service";
import { ErrorDialogComponent } from "../error-dialog/error-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSelectionListChange } from "@angular/material/list";
import { EmploymentHistoryDialogComponent } from "./employment-history-dialog/employment-history-dialog.component";

@Component({
  selector: "app-employment-history",
  templateUrl: "./employment-history.component.html",
  styleUrls: ["./employment-history.component.scss"],
})
export class EmploymentHistoryComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  maxDate = new Date();
  minDate = new Date(1900, 0, 1);
  countryMismatchFlagVal: string = "0";
  employmentGapAlertVal: string = "0";
  sticky: boolean = false;
  employmentData: AFEmploymentDomain;
  containerWidth: number;
  stepEmployment: number = 0;
  stepEmploymentBreak: number = 0;
  noEmploymentHistoryInstruction: string;
  employmentForm: UntypedFormGroup;
  reasonCodeForLeaving: KeyVal[];
  employmentChange: boolean = false;
  borderEmpHistory: boolean = false;
  borderEmpBreak: boolean = false;
  listCheckEmploymentHistory: boolean = false;
  listCheckEmploymentBreak: boolean = false;
  employmentGapInstruction: number;
  jobCountry: string = "";
  sections: string = "4";
  selectedFile: any[] = new Array(20);
  attachmentCount: number = 0;
  validFileTypes = [
    "ZIP",
    "PDF",
    "DOC",
    "DOCX",
    "EML",
    "MSG",
    "TIFF",
    "JPEG",
    "GIF",
    "XLS",
    "XLSX",
    "PNG",
    "JPG",
    "PPT",
    "PPTX",
  ];
  employmentHistoryIds: string[] = [
    "currentDojProofId",
    "currentDesignationProofId",
    "currentOfferLetterId",
    "currentCompensationLetterId",
    "currentLatestThreePaySlipId",
    "previousDojProofId",
    "previousDesignationProofId",
    "lwdProofId",
    "previousOfferLetterId",
    "previousCompensationLetterId",
    "previousLastThreeMonthPaySlipId",
  ];

  @ViewChild("stickyDiv") stickyDivElement: ElementRef;
  @ViewChildren("stickyDiv", { read: ViewContainerRef })
  viewContainerRefs: QueryList<any>;
  @ViewChild("addEmploymentHistoryElement")
  addEmploymentHistoryElement: ElementRef;
  @ViewChild("addEmploymentBreakElement") addEmploymentBreakElement: ElementRef;
  @ViewChild("addHistoryButtonElement") addHistoryButtonElement: ElementRef;
  @ViewChild("addBreakButtonElement") addBreakButtonElement: ElementRef;

  constructor(
    private userService: AuthService,
    private employmentService: EmploymentService,
    private fb: UntypedFormBuilder,
    private eventBus: EventService,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private customValidator: CustomValidatorsService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ErrorDialogComponent>
  ) {
    super(eventBus, _router);
    dialogRef.disableClose = true;
    this.countryMismatchFlagVal = "0";
    this.employmentGapAlertVal = "0";
    this.employmentGapInstruction =
      this.userService.getEmploymentGapInstruction();
    this.jobCountry = this.userService.getJobCountry();
  }

  get noEmploymentHistory() {
    return this.employmentForm.get("noEmploymentHistory");
  }
  get employmentFormControls() {
    return this.employmentForm.controls;
  }
  get submit() {
    return this.employmentForm.get("submit");
  }
  get afId() {
    return this.employmentForm.get("afId");
  }
  get employmentList() {
    return this.employmentForm.get("employmentList") as UntypedFormArray;
  }
  get employmentBreakList() {
    return this.employmentForm.get("employmentBreakList") as UntypedFormArray;
  }
  get employmentLimit() {
    return this.employmentForm.get("employmentLimit");
  }
  get bookmarkUrl() {
    return this.employmentForm.get("bookmarkUrl");
  }
  get countryMismatchFlag() {
    return this.employmentForm.get("countryMismatchFlag");
  }
  get employmentGapAlert() {
    return this.employmentForm.get("employmentGapAlert");
  }
  get employmentVerificationDate() {
    return this.employmentForm.get("employmentVerificationDate");
  }

  ngOnInit() {
    this.jobCountry = this.userService.getJobCountry();
    //initializing a 2*2 array for dynamic file save feature India
    for (let i = 0; i < 20; i++) {
      this.selectedFile[i] = new Array(12);
    }
    if (this.jobCountry == "IND") {
      this.sections = "5";
    }
    this.createGroup();
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.employmentService.getEmploymentHistory().subscribe({
      next: (data: AFEmploymentDomain) => {
        this.employmentData = data;
        this.employmentVerificationDate.setValue(
          this.employmentData.employmentVerificationDate
        );
        this.addInstruction(this.employmentData);
        this.noEmploymentHistory.setValue(
          this.employmentData.noEmploymentHistory
        );
        this.employmentGapAlert.setValue(
          this.userService.getEmploymentGapInstruction() == 1
        );
        if (!this.employmentData.emptyEmpHistory) {
          for (let employer of this.employmentData.employmentList) {
            let fg: any = this.employmentFieldsGroup();
            fg.patchValue(employer);
            //retreiving attachments from mongo
            this.addAttachmentToForm(this.employmentForm.get("employmentList"));
            this.employmentList.push(fg);
            this.setEmployerValidators(fg);
          }
        }
        if (!this.employmentData.emptyEmpBreak) {
          for (let empBreak of this.employmentData.employmentBreakList) {
            let fg: UntypedFormGroup = this.employmentBreakFieldsGroup();
            fg.patchValue(empBreak);
            this.employmentBreakList.push(fg);
            this.setEmploymentBreakValidators(fg);
          }
        }

        this.createEmploymentDialog();
      },
      error: (error: Error) => {
        console.log(error);
      }
    });

    this.sub = this.eventBus.on(ValidateAndNavigateEvent, (event): void => {
      if (event.payload.currentLink === "/employmentHistory") {
        this.submit.setValue(false);
        this.bookmarkUrl.setValue("");
        this.employmentLimit.setValue(this.employmentData.employmentLimit);
        this.countryMismatchFlag.setValue(this.countryMismatchFlagVal);
        if (this.userService.getJobCountry() == "IND") {
          this.saveFiles(this.employmentForm.value, event);
        } else {
          if (event.payload.save) {
            this.submitEmploymentHistory(this.employmentForm.value, event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.submitEmploymentHistory(this.employmentForm.value, event);
          } else {
            if (this.validate()) {
              this.submitEmploymentHistory(this.employmentForm.value, event);
            } else {
              // this.eventBus.emit(new BeforeSubmitErrorEvent({}));
            }
          }
        }
      }
    });

    this.eventBus.on(CountryMistmatchEvent, (event): void => {
      const dialogMsg =
        "Country Information is not consistent between Address History and Employment History. Please verify before moving forward.";

      this.eventBus.emit(
        new ShowErrorEvent({ httpStatus: 1, text: dialogMsg })
      );
      this.countryMismatchFlagVal = "1";
      window.scrollTo(0, 0);
    });

    this.eventBus.on(EmploymentGapEvent, (event): void => {
      const dialogMsg =
        "You have entered an employment gap of more than six months. Please refer to Employment Gap Instructions link for further information.";
      this.eventBus.emit(
        new ShowErrorEvent({ httpStatus: 1, text: dialogMsg })
      );
      window.scrollTo(0, 0);
    });

    this.eventBus.on(SkipToMainContentEvent, (event): void => {
      if (event.payload.text && event.payload.text == "/employmentHistory") {
        let mainContentElement = document.querySelector("#main-content"); //check if main-content id exists on page
        if (mainContentElement) {
          mainContentElement.scrollIntoView(true);
        }
      }
    });
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  createGroup() {
    this.employmentForm = this.fb.group({
      afId: [this.userService.getAfId(), []],
      jobCountry: [this.userService.getJobCountry(), []],
      countryMismatchFlag: [this.countryMismatchFlagVal, []],
      employmentGapAlert: [false, []],
      employmentLimit: ["", []],
      noEmploymentHistory: [false],
      employmentVerificationDate: ["", [Validators.maxLength(100)]],
      submit: [false],
      bookmarkUrl: [""],
      employmentList: new UntypedFormArray([]),
      employmentBreakList: new UntypedFormArray([]),
    });
  }

  ngAfterViewInit() {
    this.handleZoom();

    this.viewContainerRefs.changes.subscribe(() => {
      if (this.viewContainerRefs.toArray().length) {
        if (this.stickyDivElement) {
          this.containerWidth = this.stickyDivElement.nativeElement.clientWidth;
        }
      }
    });

    this.employmentForm.valueChanges.subscribe(() => {
      setTimeout(() => {
        let progress = this.getPercentage(this.employmentForm);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);

      if (this.employmentList.length != 0) {
        this.listCheckEmploymentHistory = true;
      } else {
        this.listCheckEmploymentHistory = false;
      }

      if (this.employmentBreakList.length != 0) {
        this.listCheckEmploymentBreak = true;
      } else {
        this.listCheckEmploymentBreak = false;
      }
    });

    // retain navigation on page refresh
    let navlink = this.userService
      .getNavLinks()
      .find((e) => e.routerLink === "/employmentHistory");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));
  }

  async saveFiles(employmentHistory, event) {
    //storing file in mongo and adding the ids for the same
    for (let i = 0; i < employmentHistory.employmentList.length; i++) {
      for (let j = 0; j < 11; j++) {
        //attachmentid null check for saving mongo
        let attachmentId = this.employmentList
          .at(i)
          .get(this.employmentHistoryIds[j])?.value;
        if (attachmentId == "filled" && this.selectedFile[i][j] != null) {
          const fd = new FormData();
          fd.append("file", this.selectedFile[i][j]);
          fd.append("verifyId", this.userService.getVerifyId());
          fd.append("ousAttachmentId", j <= 5 ? "59" : "60");
          fd.append("descriptionOfFile", "");
          fd.append("asiComponentId", "");
          fd.append("asiCaseId", "");
          fd.append("applicantFormId", "");

          const resp = await this.employmentService
            .saveFiles(fd)
            .then((res) => {
              this.employmentList
                .at(i)
                .get(this.employmentHistoryIds[j])
                .setValue(res.mongoAttachmentId);
            })
            .catch((err) => {
              this.employmentList
                .at(i)
                .get(this.employmentHistoryIds[j])
                .setValue(null);
              this.selectedFile[i][j] = null;
              this._snackBar.open(
                "Submission failed Error while saving the attachments" +
                err.error,
                "Close",
                {
                  duration: 4000,
                }
              );
              return false;
            });
          if (resp == false) {
            return false;
          }
        } else if (
          typeof this.selectedFile[i][j] == "string" &&
          this.selectedFile[i][j]?.length > 0 &&
          this.selectedFile[i][j] != "filled"
        ) {
          const resp = await this.userService
            .removeMongoAttachmentPromise(this.selectedFile[i][j])
            .then((res) => {
              if (res == "SUCCESS")
                this.employmentList
                  .at(i)
                  .get(this.employmentHistoryIds[j])
                  ?.setValue(null);
            })
            .catch((error) => {
              this._snackBar.open(
                "Attachment deletion got failed" + error.error,
                "Close",
                {
                  duration: 4000,
                }
              );
              return false;
            });
          if (resp == false) {
            return false;
          }
        }
      }
    }

    //after completing all the files save and deletion. final submit call
    if (event.payload.save) {
      this.submitEmploymentHistory(this.employmentForm.value, event);
    } else if (event.payload.saveAndFinishLater) {
      this.bookmarkUrl.setValue(event.payload.currentLink);
      this.submitEmploymentHistory(this.employmentForm.value, event);
    } else {
      if (this.validate()) {
        this.submitEmploymentHistory(this.employmentForm.value, event);
      } else {
        this.eventBus.emit(new BeforeSubmitErrorEvent({}));
      }
    }
  }

  submitEmploymentHistory(employmentHistory, event) {
    this.employmentService.submitEmploymentHistory(employmentHistory).subscribe({
      next: () => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(["sessionTimedOut"]);
        } else {
          this.eventBus.emit(
            new ChangeNavigationEvent({ id: event.payload.id })
          );
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      },
      error: (error: any) => {
        this._snackBar.open("An error occurred while attempting to save Employment History", "Close", { duration: 4000 });
        console.log(error)
      }
    });
  }

  setEmploymentStep(index: number) {
    this.stepEmployment = index;
  }

  setEmploymentBreakStep(index: number) {
    this.stepEmploymentBreak = index;
  }

  addInstruction(employmentData: AFEmploymentDomain) {
    let years = "years";
    if (employmentData.employmentLimit == 1) {
      years = "year";
    }
    this.noEmploymentHistoryInstruction =
      "I have no employment history or employment breaks to list within the last " +
      (employmentData.employmentLimit == 55
        ? 10
        : employmentData.employmentLimit) +
      " " +
      years;
  }

  hasEmploymentHistory() {
    return this.employmentList.length > 0;
  }

  hasEmploymentBreakHistory() {
    return this.employmentBreakList.length > 0;
  }

  employmentFieldsGroup(): UntypedFormGroup {
    return this.fb.group(
      {
        //Employer details
        isCurrentEmployer: ["", [Validators.required]],
        noticePeriod: ["", [Validators.required]],
        noticePeriodDays: [""],
        canContactNow: [""],
        hasAgency: ["", [Validators.required]],
        employmentStartDate: [
          "",
          [Validators.required, Validators.maxLength(100)],
        ],
        employmentEndDate: ["", [Validators.maxLength(100)]],
        employerName: [
          "",
          [
            Validators.required,
            Validators.maxLength(200),
            this.customValidator.validateRequiredField,
          ],
        ],
        position: [
          "",
          [
            Validators.required,
            Validators.maxLength(200),
            this.customValidator.validateRequiredField,
          ],
        ],
        employmentType: ["", [Validators.required]],
        natureOfEmployment: [""],
        managerDesignation: [""],
        managerStillEmployed: [""],
        businessTypeEmployer: ["", [Validators.required]],
        workDescription: [
          "",
          [
            Validators.required,
            Validators.maxLength(1000),
            this.customValidator.validateRequiredField,
          ],
        ],
        streetAddressOne: [
          "",
          [
            Validators.required,
            Validators.maxLength(100),
            this.customValidator.validateRequiredField,
          ],
        ],
        streetAddressTwo: ["", [Validators.maxLength(150)]],
        streetAddressThree: ["", [Validators.maxLength(255)]],
        zipCode: [
          "",
          [
            Validators.required,
            Validators.maxLength(13),
            this.customValidator.validateRequiredField,
          ],
        ],
        city: [
          "",
          [
            Validators.required,
            Validators.maxLength(100),
            this.customValidator.validateRequiredField,
          ],
        ],
        country: ["", [Validators.required]],
        usState: [""],
        state: [
          "",
          [
            Validators.maxLength(30),
            this.customValidator.validateRequiredField,
          ],
        ],
        reason: [""],
        reasonCode: [""],
        addnlDetailsForRFL: [
          "",
          [
            Validators.maxLength(1000),
            this.customValidator.validateRequiredField,
          ],
        ],
        businessPhoneNumber: ["", [Validators.minLength(9)]],
        employerWebsite: ["", [Validators.maxLength(100)]],
        managerName: [
          "",
          [
            Validators.required,
            Validators.maxLength(200),
            this.customValidator.validateRequiredField,
          ],
        ],
        managerPhoneNumber: [
          "",
          [Validators.required, Validators.minLength(9)],
        ],
        managerEmailAddress: [
          "",
          [Validators.email, Validators.maxLength(200)],
        ],
        agencyName: [
          "",
          [
            Validators.maxLength(250),
            this.customValidator.validateRequiredField,
          ],
        ],
        agencyContactDetails: [
          "",
          [
            Validators.maxLength(250),
            this.customValidator.validateRequiredField,
          ],
        ],
        agencyAddress: [
          "",
          [
            Validators.maxLength(250),
            this.customValidator.validateRequiredField,
          ],
        ],
        reasonCodeForLeavingLookup: [null],
        checkIsCurrentEmployer: [false],
        checkCanContactNow: [false],
        checkNoticePeriod: [false],
        checkhasAgency: [false],
        currentRemunaration: [""],
        fixedOrVariable: [""],
        currentDojProof: [""],
        currentDojProofId: [""],
        currentDesignationProof: [""],
        currentDesignationProofId: [""],
        currentOfferLetter: [""],
        currentOfferLetterId: [""],
        currentCompensationLetter: [""],
        currentCompensationLetterId: [""],
        currentLatestThreePaySlip: [""],
        currentLatestThreePaySlipId: [""],
        previousDojProof: [""],
        previousDojProofId: [""],
        previousDesignationProof: [""],
        previousDesignationProofId: [""],
        lwdProof: [""],
        lwdProofId: [""],
        previousOfferLetter: [""],
        previousOfferLetterId: [""],
        previousCompensationLetter: [""],
        previousCompensationLetterId: [""],
        previousLastThreeMonthPaySlip: [""],
        previousLastThreeMonthPaySlipId: [""],
      },
      { validators: employmentValidator() }
    );
  }

  employmentBreakFieldsGroup(): UntypedFormGroup {
    return this.fb.group(
      {
        //Break details
        isCurrentEmploymentStatus: ["", [Validators.required]],
        employmentBreakFromDate: [
          "",
          [Validators.required, Validators.maxLength(100)],
        ],
        employmentBreakToDate: ["", [Validators.maxLength(100)]],
        employmentBreakReason: ["", [Validators.required]],
        employmentBreakComment: [
          "",
          [
            Validators.required,
            Validators.maxLength(1000),
            this.customValidator.validateRequiredField,
          ],
        ],
        checkisCurrentEmploymentStatus: [false],
      },
      { validators: employmentBreakValidator() }
    );
  }

  onAddEmployer() {
    setTimeout(() => {
      this.addEmploymentHistoryElement.nativeElement.focus();
      this.borderEmpHistory = true;
    });
    this.createComponent();
  }

  createComponent() {
    let fg: UntypedFormGroup = this.employmentFieldsGroup();
    this.employmentList.push(fg);
    this.stepEmployment = this.employmentList.length - 1;
    this.submit.setValue(false);
    this.setEmployerValidators(fg);
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  onAddBreak() {
    setTimeout(() => {
      this.addEmploymentBreakElement.nativeElement.focus();
      this.borderEmpBreak = true;
    });
    this.createBreakComponent();
  }

  createBreakComponent() {
    let fg: UntypedFormGroup = this.employmentBreakFieldsGroup();
    this.employmentBreakList.push(fg);
    this.stepEmploymentBreak = this.employmentBreakList.length - 1;
    this.submit.setValue(false);
    this.setEmploymentBreakValidators(fg);
  }

  validate() {
    if (this.noEmploymentHistory.value) {
      return true;
    }
    this.submit.setValue(true);
    this.employmentForm.markAllAsTouched();
    if (this.employmentForm && this.employmentForm.invalid) {
      let isInvalid = true;
      const firstInvalidField = Object.keys(this.employmentForm.controls).find(field => this.employmentForm.get(field)?.invalid);
      if (this.employmentForm.controls[firstInvalidField] instanceof FormArray) {
        (<FormArray>this.employmentForm.controls[firstInvalidField]).controls.forEach((data: FormGroup) => {
          if (data.invalid && isInvalid) {
            this.userService.setFocus(data);
            isInvalid = false;
          }
        })
      } else {
        this.userService.setFocus(this.employmentForm);
      }
    }
    return !this.employmentForm.invalid;
  }

  @HostListener("window:resize", ["$event"])
  @HostListener("window:load", ["$event"])
  handleZoom() {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    if (
      windowWidth <= AF_CONSTANTS.windowWidth ||
      windowHeight <= AF_CONSTANTS.windowHeight
    ) {
      this.employmentChange = true;
    } else {
      this.employmentChange = false;
    }
  }

  getPercentage(employmentForm: UntypedFormGroup): number {
    let errorCount = 0;
    let totalCount = 0;

    if (this.noEmploymentHistory.value) {
      return 100;
    }

    let channelArray: Array<string> = [
      "managerEmailAddress",
      "employerWebsite",
      "businessPhoneNumber",
      "streetAddressThree",
      "streetAddressTwo",
    ];
    for (let container of employmentForm.get("employmentList")["controls"]) {
      for (let controlKey in container.controls) {
        if (channelArray.some((x) => x === controlKey)) {
          continue;
        }

        if (container.controls.hasOwnProperty(controlKey)) {
          let control = container.controls[controlKey];
          if (control.validator != null) {
            totalCount += container.controls[controlKey].validator.length;
            if (control.errors) {
              errorCount += Object.keys(control.errors).length;
            }
          }
        }
      }
    }

    for (let container of employmentForm.get("employmentBreakList")[
      "controls"
    ]) {
      for (let controlKey in container.controls) {
        if (container.controls.hasOwnProperty(controlKey)) {
          let control = container.controls[controlKey];

          if (control.validator != null) {
            totalCount += container.controls[controlKey].validator.length;
            if (control.errors) {
              errorCount += Object.keys(control.errors).length;
            }
          }
        }
      }
    }
    let percentage = ((totalCount - errorCount) / totalCount) * 100;

    return percentage;
  }

  onReasonChange(reason: MatSelectChange, reasonCodeControl: AbstractControl) {
    let reasonValue: string = reason.value;

    if (reasonValue == undefined) {
      reasonValue = "0";
    }

    this.employmentService.getReasonCodeForLeaving(reasonValue).subscribe({
      next: (data) => {
        reasonCodeControl.setValue(data);
      },
      error: (error: any) => console.log(error)
    });
  }

  @HostListener("window:scroll", ["$event"])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (
      windowScroll >= AF_CONSTANTS.windowScroll_Lower_limit &&
      windowScroll <= AF_CONSTANTS.windowScroll_Upper_limit_employment
    ) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }
  }

  @HostListener("document:keydown", ["$event"])
  clearBorder(event: KeyboardEvent) {
    if (event.key === "Tab") {
      this.borderEmpHistory = false;
      this.borderEmpBreak = false;
    }
  }

  @HostListener("click", ["$event"])
  clearBorderClick(event: MouseEvent) {
    this.borderEmpHistory = false;
    this.borderEmpBreak = false;
  }

  handleEmploymentSelection(event: MatSelectionListChange, index) {
    event.source.deselectAll();
    event.options[0]._setSelected(true);
    this.stepEmployment = event.options[0].value;
  }

  handleEmploymentBreakSelection(event, index) {
    event.source.deselectAll();
    event.options[0]._setSelected(true);
    this.stepEmploymentBreak = event.options[0].value;
  }

  isCurrentEmployerChanges(employmentForm: UntypedFormGroup) {
    employmentForm.controls.noticePeriod.setValue("");
    //resetting of attachments on switching of employment
    for (let i = 0; i < 20; i++) {
      for (let j = 0; j < 11; j++) {
        this.selectedFile[i] = new Array(12);
      }
    }
    if (
      employmentForm.controls &&
      employmentForm.controls.isCurrentEmployer &&
      employmentForm.controls.isCurrentEmployer.value == 1
    ) {
      employmentForm.addValidators(Validators.required);
      employmentForm.controls.previousDojProofId?.removeValidators([
        Validators.required,
      ]);
      employmentForm.controls.previousDesignationProofId?.removeValidators([
        Validators.required,
      ]);
      employmentForm.controls.lwdProofId?.removeValidators([
        Validators.required,
      ]);
    } else {
      employmentForm.controls.noticePeriod.removeValidators(
        Validators.required
      );
      employmentForm.controls.currentDojProofId?.removeValidators([
        Validators.required,
      ]);
      employmentForm.controls.currentDesignationProofId?.removeValidators([
        Validators.required,
      ]);
    }
  }

  isNoticePeriodChange(employmentForm: UntypedFormGroup) {
    employmentForm.controls.noticePeriodDays.setValue("");
    if (
      employmentForm.controls &&
      employmentForm.controls.noticePeriod &&
      employmentForm.controls.noticePeriod.value == 1
    ) {
      employmentForm.addValidators(Validators.required);
    } else {
      employmentForm.controls.noticePeriodDays.removeValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(120),
        Validators.maxLength(3),
        Validators.pattern("^[0-9]*$"),
      ]);
    }
  }

  onChangeNoEmploymentHistory(mrChange: MatCheckboxChange) { }

  getKey(val: string): KeyVal {
    let empLookup: KeyVal[] = this.employmentData.reasonEmploymentBreakLookup;
    let i: number = 0;
    let values = Object.keys(empLookup).map((e) => empLookup[e]);

    for (let value of values) {
      if (i === Number(val) - 1) {
        return value;
      }
      i++;
    }
  }

  valueAscOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    try {
      return a.value.localeCompare(b.value);
    } catch (e) {
      console.log(e);
    }
  };

  valueAscOrderOtherLast = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    try {
      if (a.value == "Other") {
        return 1;
      }
      if (b.value == "Other") {
        return -1;
      }
      return a.value.localeCompare(b.value);
    } catch (e) {
      console.log(e);
    }
  };

  idAscOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    if (a.key > b.key) {
      return 1;
    }
    if (a.key < b.key) {
      return -1;
    }
    return 0;
  };

  deleteEmploymentClick(i) {
    this.employmentList.removeAt(i);
    if (i == this.employmentList.length) {
      this.stepEmployment = i - 1;
    }

    setTimeout(() => {
      if (this.employmentList && this.employmentList.length == 0) {
        this.addHistoryButtonElement.nativeElement.focus();
        this.borderEmpHistory = false;
      } else {
        this.addEmploymentHistoryElement.nativeElement.focus();
        this.borderEmpHistory = true;
      }
    });
  }

  clickEmploymentGapInstructions() {
    this.employmentGapAlert.setValue(false);
  }

  deleteEmploymentBreakClick(i) {
    this.employmentBreakList.removeAt(i);
    if (i == this.employmentBreakList.length) {
      this.stepEmploymentBreak = i - 1;
    }

    setTimeout(() => {
      if (this.employmentBreakList && this.employmentBreakList.length == 0) {
        this.addBreakButtonElement.nativeElement.focus();
        this.borderEmpBreak = false;
      } else {
        this.addEmploymentBreakElement.nativeElement.focus();
        this.borderEmpBreak = true;
      }
    });
  }

  dropDownScreenReaderCountry(employer: any): string {
    if (employer.controls.country.value) {
      return (
        "Selected " +
        this.employmentData.countryLookup[
        Object.keys(this.employmentData.countryLookup).find(
          (e) => e === employer.controls.country.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderState(employer: any): string {
    if (employer.controls.usState.value) {
      return (
        "Selected " +
        this.employmentData.usStateLookup[
        Object.keys(this.employmentData.usStateLookup).find(
          (e) => e === employer.controls.usState.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderTypeOfEmployment(employer: any): string {
    if (employer.controls.employmentType.value) {
      return (
        "Selected " +
        this.employmentData.typeOfEmploymentLookup[
        Object.keys(this.employmentData.typeOfEmploymentLookup).find(
          (e) => e === employer.controls.employmentType.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderNatureOfEmployment(employer: any): string {
    if (employer.controls.natureOfEmployment.value) {
      return (
        "Selected " +
        this.employmentData.natureOfEmploymentLookup[
        Object.keys(this.employmentData.natureOfEmploymentLookup).find(
          (e) => e === employer.controls.natureOfEmployment.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderBusinessTypeEmployer(employer: any): string {
    if (employer.controls.businessTypeEmployer.value) {
      return (
        "Selected " +
        this.employmentData.typeOfEmployerLookup[
        Object.keys(this.employmentData.typeOfEmployerLookup).find(
          (e) => e === employer.controls.businessTypeEmployer.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderemploymentBreakReason(employer: any): string {
    if (employer.controls.employmentBreakReason.value) {
      return (
        "Selected " +
        this.employmentData.reasonEmploymentBreakLookup[
        Object.keys(this.employmentData.reasonEmploymentBreakLookup).find(
          (e) => e === employer.controls.employmentBreakReason.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderReasonForLeaving(employer: any): string {
    if (employer.controls.reason.value) {
      return (
        "Selected " +
        this.employmentData.reasonForLeavingLookup[
        Object.keys(this.employmentData.reasonForLeavingLookup).find(
          (e) => e === employer.controls.reason.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  dropDownScreenReaderReasonCode(employer: any): string {
    if (employer.controls.reasonCode.value) {
      return (
        "Selected " +
        employer.controls.reasonCodeForLeavingLookup.value[
        Object.keys(employer.controls.reasonCodeForLeavingLookup.value).find(
          (e) => e === employer.controls.reasonCode.value
        )
        ]
      );
    } else {
      return "blank";
    }
  }

  focusTargetEmployment() {
    setTimeout(() => {
      this.addEmploymentHistoryElement.nativeElement.focus();
      this.borderEmpHistory = true;
    });
  }

  focusTargetEmploymentBreak() {
    setTimeout(() => {
      this.addEmploymentBreakElement.nativeElement.focus();
      this.borderEmpBreak = true;
    });
  }

  setEmployerValidators(control: UntypedFormGroup) {
    const isCurrentEmployerControl = control.get("isCurrentEmployer");
    const countryControl = control.get("country");
    const hasAgencyControl = control.get("hasAgency");
    const noticePeriodControl = control.get("noticePeriod");
    const workDescriptionControl = control.get("workDescription");
    const reasonCodeControl = control.get("reasonCode");
    const addnlDetailsForRFLControl = control.get("addnlDetailsForRFL");
    const managerStillEmployedControl = control.get("managerStillEmployed");
    isCurrentEmployerControl.valueChanges.subscribe(
      (isCurrentEmployerControlValue) => {
        this.setIsCurrentEmployerValidations(
          control,
          isCurrentEmployerControlValue
        );
      }
    );

    noticePeriodControl.valueChanges.subscribe((noticePeriodControlValue) => {
      this.setNoticePeriodValidations(control, noticePeriodControlValue);
    });

    countryControl.valueChanges.subscribe((countryControlValue) => {
      this.setCountryValidations(control, countryControlValue);
    });

    hasAgencyControl.valueChanges.subscribe((hasAgencyControlValue) => {
      this.setHasAgencyValidations(control, hasAgencyControlValue);
    });
    if (this.jobCountry == "IND") {
      this.clearValidators(hasAgencyControl);
      this.setHasAgencyValidations(control, "0");
      this.clearValidators(workDescriptionControl);
      this.clearValidators(reasonCodeControl);
      this.clearValidators(addnlDetailsForRFLControl);
      this.addValidators(managerStillEmployedControl);
    }
  }

  clearValidators(control: AbstractControl) {
    control?.reset();
    control?.clearValidators();
    control?.setErrors(null);
    control?.updateValueAndValidity();
  }

  addValidators(control: AbstractControl) {
    control?.setValidators([Validators.required]);
    control?.updateValueAndValidity();
  }

  createEmploymentDialog() {
    // check this part of OUS list to show the popup
    let jobCountryCode = this.userService.getJobCountry();
    if (jobCountryCode && jobCountryCode !== "USA") {
      // invoke pop-up
      const dialogRef = this.dialog.open(EmploymentHistoryDialogComponent, {
        ariaLabel: "Employment History Dialog",
        role: "alertdialog",
        height: "auto",
        width: "600px",
        maxWidth: "90vw",
        maxHeight: "98vh",
        autoFocus: false,
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(() => {
        window.scrollTo(0, 0);
      });
    }
  }

  setNoticePeriodValidations(
    control: UntypedFormGroup,
    noticePeriodControlValue: string
  ) {
    const noticePeriodDaysControl = control.get("noticePeriodDays");
    if (noticePeriodControlValue === "0") {
      noticePeriodDaysControl.setValidators(null);
      noticePeriodDaysControl.setErrors(null);
      noticePeriodDaysControl.setValue(null);
    } else if (noticePeriodControlValue === "1") {
      noticePeriodDaysControl.setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(120),
        Validators.maxLength(3),
        Validators.pattern("^[0-9]*$"),
      ]);
    } else {
      noticePeriodDaysControl.setValidators(null);
    }
    noticePeriodDaysControl.updateValueAndValidity();
  }

  setIsCurrentEmployerValidations(
    control: UntypedFormGroup,
    isCurrentEmployerValue: string
  ) {
    const employmentEndDateControl = control.get("employmentEndDate");
    const canContactNowControl = control.get("canContactNow");
    const reasonControl = control.get("reason");
    const reasonCodeControl = control.get("reasonCode");
    const addnlDetailsForRFLControl = control.get("addnlDetailsForRFL");
    const noticePeriodControl = control.get("noticePeriod");
    const noticePeriodDaysControl = control.get("noticePeriodDays");
    const currentDojControl = control.get("currentDojProofId");
    const currentDesignationControl = control.get("currentDesignationProofId");
    const currentOfferControl = control.get("currentOfferLetterId");
    const currentCompensationControl = control.get(
      "currentCompensationLetterId"
    );
    const currentLatestPayslipControl = control.get(
      "currentLatestThreePaySlipId"
    );

    const previousDojControl = control.get("previousDojProofId");
    const previousDesignationControl = control.get(
      "previousDesignationProofId"
    );
    const previousLwdProofControl = control.get("lwdProofId");
    const previousOfferControl = control.get("previousOfferLetterId");
    const previousCompensationControl = control.get(
      "previousCompensationLetterId"
    );
    const previousLatestPayslipControl = control.get(
      "previousLastThreeMonthPaySlipId"
    );

    if (isCurrentEmployerValue === "0") {
      employmentEndDateControl.setValidators([Validators.required]);
      reasonControl.setValidators([Validators.required]);
      if (this.jobCountry != "IND") {
        reasonCodeControl.setValidators([Validators.required]);
        addnlDetailsForRFLControl.setValidators([
          Validators.required,
          this.customValidator.validateRequiredField,
        ]);
      }

      currentDojControl.setValue(null);
      currentDesignationControl.setValue(null);
      currentOfferControl.setValue(null);
      currentCompensationControl.setValue(null);
      currentLatestPayslipControl.setValue(null);

      currentDojControl.setErrors(null);
      currentDesignationControl.setErrors(null);

      canContactNowControl.setValidators(null);
      canContactNowControl.setErrors(null);
      canContactNowControl.setValue(null);
      noticePeriodControl.setValidators(null);
      noticePeriodControl.setErrors(null);
      noticePeriodControl.setValue(null);
      noticePeriodDaysControl.setValidators(null);
      noticePeriodDaysControl.setErrors(null);
      noticePeriodDaysControl.setValue(null);
    } else if (isCurrentEmployerValue === "1") {
      canContactNowControl.setValidators([Validators.required]);
      noticePeriodControl.setValidators([Validators.required]);
      employmentEndDateControl.setValidators(null);
      employmentEndDateControl.setErrors(null);
      reasonControl.setValidators(null);
      reasonControl.setErrors(null);
      reasonCodeControl.setValidators(null);
      reasonCodeControl.setErrors(null);
      addnlDetailsForRFLControl.setValidators(null);
      addnlDetailsForRFLControl.setErrors(null);

      previousDojControl.setValue(null);
      previousDesignationControl.setValue(null);
      previousLwdProofControl.setValue(null);
      previousOfferControl.setValue(null);
      previousCompensationControl.setValue(null);
      previousLatestPayslipControl.setValue(null);
      previousDojControl.setErrors(null);
      previousDesignationControl.setErrors(null);
      previousLwdProofControl.setErrors(null);
    } else {
      canContactNowControl.setValidators(null);
      noticePeriodControl.setValidators(null);
      noticePeriodDaysControl.setValidators(null);
      employmentEndDateControl.setValidators(null);
      employmentEndDateControl.setErrors(null);
      reasonControl.setValidators(null);
      reasonControl.setErrors(null);
      reasonCodeControl.setValidators(null);
      reasonCodeControl.setErrors(null);
      addnlDetailsForRFLControl.setValidators(null);
      addnlDetailsForRFLControl.setErrors(null);
    }
    employmentEndDateControl.updateValueAndValidity();
    canContactNowControl.updateValueAndValidity();
    noticePeriodControl.updateValueAndValidity();
    noticePeriodDaysControl.updateValueAndValidity();
    reasonControl.updateValueAndValidity();
    reasonCodeControl.updateValueAndValidity();
    addnlDetailsForRFLControl.updateValueAndValidity();
  }

  setCountryValidations(control: UntypedFormGroup, countryControl: string) {
    const usStateControl = control.get("usState");
    const stateControl = control.get("state");

    if (countryControl === "186") {
      usStateControl.setValidators([Validators.required]);
      stateControl.setValidators(null);
      stateControl.setErrors(null);
    } else if (countryControl != null) {
      stateControl.setValidators([
        Validators.required,
        this.customValidator.validateRequiredField,
      ]);
      usStateControl.setValidators(null);
      usStateControl.setErrors(null);
    } else {
      stateControl.setValidators([
        Validators.required,
        this.customValidator.validateRequiredField,
      ]);
      usStateControl.setValidators(null);
      usStateControl.setErrors(null);
    }
    usStateControl.updateValueAndValidity();
    stateControl.updateValueAndValidity();
  }

  setHasAgencyValidations(
    control: UntypedFormGroup,
    hasAgencyControlValue: string
  ) {
    const agencyNameControl = control.get("agencyName");
    const agencyContactDetailsControl = control.get("agencyContactDetails");
    const agencyAddressControl = control.get("agencyAddress");

    if (hasAgencyControlValue === "1") {
      agencyNameControl.setValidators([
        Validators.required,
        this.customValidator.validateRequiredField,
      ]);
      agencyContactDetailsControl.setValidators([
        Validators.required,
        this.customValidator.validateRequiredField,
      ]);
      agencyAddressControl.setValidators([
        Validators.required,
        this.customValidator.validateRequiredField,
      ]);
    } else if (hasAgencyControlValue === "0") {
      agencyNameControl.setValidators(null);
      agencyNameControl.setErrors(null);
      agencyContactDetailsControl.setValidators(null);
      agencyContactDetailsControl.setErrors(null);
      agencyAddressControl.setValidators(null);
      agencyAddressControl.setErrors(null);
    } else {
      agencyNameControl.setValidators(null);
      agencyContactDetailsControl.setValidators(null);
      agencyAddressControl.setValidators(null);
    }
    agencyNameControl.updateValueAndValidity();
    agencyContactDetailsControl.updateValueAndValidity();
    agencyAddressControl.updateValueAndValidity();
  }

  setEmploymentBreakValidators(control: UntypedFormGroup) {
    const isCurrentEmploymentStatusControl = control.get(
      "isCurrentEmploymentStatus"
    );
    const employmentBreakToDateControl = control.get("employmentBreakToDate");

    isCurrentEmploymentStatusControl.valueChanges.subscribe(
      (isCurrentEmploymentStatusControl) => {
        if (isCurrentEmploymentStatusControl === "0") {
          employmentBreakToDateControl.setValidators([Validators.required]);
        } else {
          employmentBreakToDateControl.setValidators(null);
          employmentBreakToDateControl.setErrors(null);
        }
        employmentBreakToDateControl.updateValueAndValidity();
      }
    );
  }

  currentOnBlur(employmentForm: UntypedFormGroup) {
    if (employmentForm.controls.isCurrentEmployer.value) {
      employmentForm.controls.checkIsCurrentEmployer.setValue(false);
    } else {
      employmentForm.controls.checkIsCurrentEmployer.setValue(true);
    }
  }

  currentOnFocus(employmentForm: UntypedFormGroup) {
    employmentForm.controls.checkIsCurrentEmployer.setValue(false);
  }

  canContactNowOnBlur(employmentForm: UntypedFormGroup) {
    if (employmentForm.controls.canContactNow.value) {
      employmentForm.controls.checkCanContactNow.setValue(false);
    } else {
      employmentForm.controls.checkCanContactNow.setValue(true);
    }
  }

  canContactNowOnFocus(employmentForm: UntypedFormGroup) {
    employmentForm.controls.checkCanContactNow.setValue(false);
  }

  haveNoticePeriodOnBlur(employmentForm: UntypedFormGroup) {
    if (employmentForm.controls.noticePeriod.value) {
      employmentForm.controls.checkNoticePeriod.setValue(false);
    } else {
      employmentForm.controls.checkNoticePeriod.setValue(true);
    }
  }

  haveNoticePeriodOnFocus(employmentForm: UntypedFormGroup) {
    employmentForm.controls.checkNoticePeriod.setValue(false);
  }

  hasAgencyOnBlur(employmentForm: UntypedFormGroup) {
    if (employmentForm.controls.hasAgency.value) {
      employmentForm.controls.checkhasAgency.setValue(false);
    } else {
      employmentForm.controls.checkhasAgency.setValue(true);
    }
  }

  hasAgencyOnFocus(employmentForm: UntypedFormGroup) {
    employmentForm.controls.checkhasAgency.setValue(false);
  }

  isCurrentEmploymentStatusOnBlur(employmentForm: UntypedFormGroup) {
    if (employmentForm.controls.isCurrentEmploymentStatus.value) {
      employmentForm.controls.checkisCurrentEmploymentStatus.setValue(false);
    } else {
      employmentForm.controls.checkisCurrentEmploymentStatus.setValue(true);
    }
  }

  isCurrentEmploymentStatusOnFocus(employmentForm: UntypedFormGroup) {
    employmentForm.controls.checkisCurrentEmploymentStatus.setValue(false);
  }

  //file selection type validations
  maxFileSupportedInMb = 5;
  getFileSizeInMb = (size) => size / (1024 * 1024);

  onFileSelected(event: any, pos: number, field: string, arr): void {
    let file: File = event.target.files[0];
    let fileSplit = file?.size > 0 ? file.name.split(".") : [];

    if (file?.size == 0) {
      this.removeAttachment(event, arr, pos, field);
      this._snackBar.open("Selected file is Empty", "Close", { duration: 4000 });
    } else if (this.getFileSizeInMb(file?.size) > this.maxFileSupportedInMb) {
      this.removeAttachment(event, arr, pos, field);
      this._snackBar.open(
        "Selected file size cannot exceed 5MB",
        "Close",
        { duration: 4000 }
      );
    } else if (
      fileSplit?.length > 0 &&
      this.validFileTypes.includes(fileSplit[1].toUpperCase())
    ) {
      this.selectedFile[arr][pos] = file;
      this.employmentList.at(arr).get(field).setValue("filled");
    } else {
      this.removeAttachment(event, arr, pos, field);
      this._snackBar.open(
        "Please select attachment of types ZIP, PDF, DOC, DOCX, EML, MSG, TIFF, JPEG, GIF, XLS, XLSX, PNG, JPG, PPT and PPTX ",
        "Close",
        { duration: 8000 }
      );
    }
  }

  removeAttachment(event: any, arr, pos, field) {
    event.target.value = null;
    this.selectedFile[arr][pos] = this.employmentList.at(arr).get(field)?.value;
    this.employmentList.at(arr).get(field).setValue("");
  }

  //checking the not null attachmentids
  addAttachmentToForm(arr: any) {
    const empListItem = this.employmentData.employmentList[arr.length];
    if (empListItem.currentDojProofId != null) {
      this.getAttachment(
        empListItem.currentDojProofId,
        arr,
        "currentDojProofId",
        "currentDojProof"
      );
    }
    if (empListItem.currentDesignationProofId != null) {
      this.getAttachment(
        empListItem.currentDesignationProofId,
        arr,
        "currentDesignationProofId",
        "currentDesignationProof"
      );
    }
    if (empListItem.currentOfferLetterId != null) {
      this.getAttachment(
        empListItem.currentOfferLetterId,
        arr,
        "currentOfferLetterId",
        "currentOfferLetter"
      );
    }
    if (empListItem.currentCompensationLetterId != null) {
      this.getAttachment(
        empListItem.currentCompensationLetterId,
        arr,
        "currentCompensationLetterId",
        "currentCompensationLetter"
      );
    }
    if (empListItem.currentLatestThreePaySlipId != null) {
      this.getAttachment(
        empListItem.currentLatestThreePaySlipId,
        arr,
        "currentLatestThreePaySlipId",
        "currentLatestThreePaySlip"
      );
    }
    if (empListItem.previousDojProofId != null) {
      this.getAttachment(
        empListItem.previousDojProofId,
        arr,
        "previousDojProofId",
        "previousDojProof"
      );
    }
    if (empListItem.previousDesignationProofId != null) {
      this.getAttachment(
        empListItem.previousDesignationProofId,
        arr,
        "previousDesignationProofId",
        "previousDesignationProof"
      );
    }
    if (empListItem.lwdProofId != null) {
      this.getAttachment(empListItem.lwdProofId, arr, "lwdProofId", "lwdProof");
    }
    if (empListItem.previousOfferLetterId != null) {
      this.getAttachment(
        empListItem.previousOfferLetterId,
        arr,
        "previousOfferLetterId",
        "previousOfferLetter"
      );
    }
    if (empListItem.previousCompensationLetterId != null) {
      this.getAttachment(
        empListItem.previousCompensationLetterId,
        arr,
        "previousCompensationLetterId",
        "previousCompensationLetter"
      );
    }
    if (empListItem.previousLastThreeMonthPaySlipId != null) {
      this.getAttachment(
        empListItem.previousLastThreeMonthPaySlipId,
        arr,
        "previousLastThreeMonthPaySlipId",
        "previousLastThreeMonthPaySlip"
      );
    }
  }

  getAttachment(attachmentId: string, arr, field: string, field2: string) {
    this.employmentService
      .getMongoAttachments(attachmentId)
      .subscribe((response) => {
        let fileName;

        const contentDisposition = response.headers.get("Content-Disposition");
        if (contentDisposition) {
          const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = fileNameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
        }
        const fileContent = response.body;
        const blob = new Blob([fileContent], {
          type: "application/octet-stream",
        });
        const file = new File([blob], fileName);
        this.selectedFile[arr.value.length - 1][
          this.employmentHistoryIds.indexOf(field)
        ] = file;
        // this.employmentList.at(arr.value.length-1).get(field2).setValue(file);
      });
  }

  get verifyId() {
    return this.userService.getVerifyId();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}

export class KeyValDomain {
  keyValue: KeyVal[] = [];

  add(keyValue: KeyVal) {
    this.keyValue.push(keyValue);
  }
  get(): KeyVal[] {
    return this.keyValue;
  }
}

export function employmentValidator(): ValidatorFn {
  return (control: UntypedFormGroup): ValidationErrors | null => {
    const errors: ValidationErrors = {};
    const employmentEndDateControl = control.get("employmentEndDate");
    const employmentStartDateControl = control.get("employmentStartDate");

    if (
      employmentStartDateControl.value &&
      employmentEndDateControl.value &&
      !employmentStartDateControl.errors &&
      !employmentEndDateControl.errors
    ) {
      if (employmentStartDateControl.value > employmentEndDateControl.value) {
        employmentEndDateControl.setErrors({ noMatch: true });
      } else {
        employmentEndDateControl.setErrors(null);
      }
    }
    if (control.get("isCurrentEmployer").value == 1) {
      control.get("noticePeriod").addValidators(Validators.required);
    } else {
      control.get("noticePeriod").removeValidators(Validators.required);
    }

    return Object.keys(errors).length ? errors : null;
  };
}

export function employmentBreakValidator(): ValidatorFn {
  return (control: UntypedFormGroup): ValidationErrors | null => {
    const errors: ValidationErrors = {};
    const isCurrentEmploymentStatusControl = control.get(
      "isCurrentEmploymentStatus"
    );
    const employmentBreakToDateControl = control.get("employmentBreakToDate");
    const employmentBreakFromDateControl = control.get(
      "employmentBreakFromDate"
    );

    if (isCurrentEmploymentStatusControl.value == 0) {
      if (!employmentBreakToDateControl.value) {
        employmentBreakToDateControl.setErrors({ requireError: true });
      }
    }

    if (
      employmentBreakFromDateControl.value &&
      employmentBreakToDateControl.value &&
      !employmentBreakFromDateControl.errors &&
      !employmentBreakToDateControl.errors
    ) {
      if (
        employmentBreakFromDateControl.value >
        employmentBreakToDateControl.value
      ) {
        employmentBreakToDateControl.setErrors({ noMatch: true });
      } else {
        employmentBreakToDateControl.setErrors(null);
      }
    }

    return Object.keys(errors).length ? errors : null;
  };
}
